import { RootState } from "../../../store";

export const navigationCollapsedSelector = (state: RootState) =>
  state.common.navCollapsed;
